import React, { useEffect, useState } from "react";
import { DatePicker, Drawer, Select, message } from "antd";
// import { CloseOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import { BASE_CRM_URL } from "../../../../components/config/config";
import PropTypes from "prop-types";
import Swal from "sweetalert2";

const NewPayment = ({ open, setOpen, record }) => {
  const [loading, setLoading] = useState(false);
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const [invoicePayments, setInvoicePayments] = useState([]);
  const [paymentsLoading, setPaymentsLoading] = useState(false);

  const [formData, setFormData] = useState({
    invoiceid: "",
    amount: "",

    paymentmethod: "",
    date: dayjs().format("YYYY-MM-DD"),
    note: "",
    transactionid: "",
  });

  // =========================================================
  // PREFILL PAYMENT DETAILS WHEN INVOICE IS SELECTED
  // =========================================================

  useEffect(() => {
    if (record) {
      setFormData({
        invoiceid: record.id || "",
      });
    }
  }, [record]);

  // =========================================================
  // INPUT CHANGE
  // =========================================================

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // =========================================================
  // PAYMENT MODE CHANGE
  // =========================================================

  const getInvoicePayments = async (invoiceId) => {
    if (!invoiceId) return;

    setPaymentsLoading(true);

    try {
      const response = await fetch(
        `${BASE_CRM_URL}invoice/GetInvoicesPayments?invoiceId=${invoiceId}`,
      );

      const data = await response.json();

      if (data.Status) {
        setInvoicePayments(data.ResultData || []);
      } else {
        setInvoicePayments([]);
      }
    } catch (error) {
      console.error("Error fetching invoice payments:", error);
      setInvoicePayments([]);
    } finally {
      setPaymentsLoading(false);
    }
  };
  const getPaymentMode = async () => {
    setPaymentLoading(true);
    try {
      const response = await fetch(`${BASE_CRM_URL}expenses/GetPaymentModes`);
      const data = await response.json();
      if (data?.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setPaymentOptions(options);
      } else {
        setPaymentOptions([]);
      }
    } catch (error) {
      console.error("Error fetching categories", error);
    } finally {
      setPaymentLoading(false);
    }
  };

  useEffect(() => {
    getPaymentMode();
  }, []);
  useEffect(() => {
    if (open && record?.id) {
      getInvoicePayments(record.id);
    }
  }, [open, record?.id]);
  // =========================================================
  // SUBMIT PAYMENT
  // =========================================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!record?.id) {
      message.error("Invoice ID is missing");
      return;
    }

    if (!formData.amount) {
      message.error("Please enter payment amount");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        invoiceid: Number(record.id),
        amount: Number(formData.amount),
        paymentmode: Number(selectedPayment),
        paymentmethod: formData.paymentmethod || " ",
        date: formData.date,
        note: formData.note,
        transactionid: formData.transactionid,
      };

      console.log("Payment Payload:", payload);

      const response = await axios.post(
        `${BASE_CRM_URL}payments/AddPayment`,
        payload,
      );

      if (response.data?.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data?.Message || "Payment added successfully",
          timer: 2000,
          showConfirmButton: false,
        });

        setOpen(false);

        // Reset form
        setFormData({
          invoiceid: "",
          amount: "",
          paymentmode: 1,
          paymentmethod: "Cash",
          date: dayjs().format("YYYY-MM-DD"),
          note: "",
          transactionid: "",
        });
      } else {
        message.error(response.data?.Message || "Failed to add payment");
      }
    } catch (error) {
      console.error("Add Payment Error:", error);

      message.error(
        error?.response?.data?.Message ||
          "Something went wrong while adding payment",
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // CLOSE DRAWER
  // =========================================================

  const handleClose = () => {
    if (!loading) {
      setOpen(false);
    }
  };

  return (
    <Drawer
      title={
        <div className="d-flex justify-content-between align-items-center w-100">
          <span>Add New Payment</span>
          <span className="fw-semibold badge bg-soft-info text-primary">
            {record?.InvoiceNo || "-"}
          </span>

          <div className="d-flex align-items-center gap-2">
            {/* Close Drawer */}
            <button
              type="button"
              onClick={handleClose}
              disabled={loading}
              className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
              style={{
                width: "35px",
                height: "35px",
                backgroundColor: "#e40d22",
                color: "#fff",
                border: "none",
              }}
              title="Close"
            >
              <i className="fa fa-times" />
            </button>

            {/* Save */}
            <button
              type="button"
              onClick={handleSubmit}
              disabled={loading}
              className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
              style={{
                width: "35px",
                height: "35px",
                backgroundColor: "#07f083",
                color: "#fff",
                border: "none",
              }}
              title="Save"
            >
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                />
              ) : (
                <i className="fa fa-check" />
              )}
            </button>
          </div>
        </div>
      }
      open={open}
      onClose={handleClose}
      width={600}
      destroyOnClose
      maskClosable={!loading}
      closable={false}
      // extra={
      //   <Button
      //     type="text"
      //     icon={<CloseOutlined />}
      //     onClick={handleClose}
      //     disabled={loading}
      //   />
      // }
    >
      <form onSubmit={handleSubmit}>
        <div className="row">
          {/* Amount */}
          <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">Amount Received</label>

            <div className="input-group">
              <span className="input-group-text bg-light">₹</span>

              <input
                type="number"
                name="amount"
                className="form-control"
                value={formData.amount}
                onChange={handleChange}
                placeholder="Enter amount"
                min="0"
                step="0.01"
              />
            </div>
          </div>

          {/* Payment Date */}
          <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">Payment Date</label>

            <DatePicker
              className="form-control"
              style={{ width: "100%" }}
              format="DD-MM-YYYY"
              value={formData.date ? dayjs(formData.date) : null}
              onChange={(date) => {
                handleChange({
                  target: {
                    name: "date",
                    value: date ? date.format("YYYY-MM-DD") : "",
                  },
                });
              }}
            />
          </div>

          {/* Payment Mode */}
          <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">Payment Mode</label>

            <Select
              placeholder="Select Payment Type"
              style={{ width: "100%", height: 38 }}
              allowClear
              showSearch
              optionFilterProp="label"
              options={paymentOptions}
              loading={paymentLoading}
              value={selectedPayment}
              onChange={(value) => {
                setSelectedPayment(value);
              }}
            />
          </div>

          {/* Payment Method */}
          {/* <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">Payment Method</label>

            <input
              type="text"
              name="paymentmethod"
              className="form-control"
              value={formData.paymentmethod}
              onChange={handleChange}
              placeholder="Enter payment method"
            />
          </div> */}

          {/* Transaction ID */}
          <div className="col-md-6 mb-3">
            <label className="form-label fw-semibold">Transaction ID</label>

            <input
              type="text"
              name="transactionid"
              className="form-control"
              value={formData.transactionid}
              onChange={handleChange}
              placeholder="Enter transaction ID"
            />
          </div>

          {/* Note */}
          <div className="col-12 mb-4">
            <label className="form-label fw-semibold">Note</label>

            <textarea
              name="note"
              className="form-control"
              rows={2}
              value={formData.note}
              onChange={handleChange}
              placeholder="Add a note..."
            />
          </div>

          {/* Buttons */}
          {/* <div className="col-12">
            <div className="d-flex justify-content-end gap-2">
              <button
                type="button"
                className="btn btn-light border"
                onClick={handleClose}
                disabled={loading}
              >
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-primary px-4"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    />
                    Saving...
                  </>
                ) : (
                  <>Save</>
                )}
              </button>
            </div>
          </div> */}
        </div>
      </form>

      {/* Payment History */}
      <div className="col-12 mt-3">
        <div className="border-top pt-3">
          <h6 className="fw-semibold mb-3">Payment History</h6>

          {paymentsLoading ? (
            <div className="text-center py-3">
              <span className="spinner-border spinner-border-sm me-2" />
              Loading payments...
            </div>
          ) : invoicePayments.length === 0 ? (
            <div className="text-center text-muted py-3 border rounded">
              No payments found
            </div>
          ) : (
            <>
              {/* Payment Summary */}
              <div className="row g-2 mb-3">
                <div className="col-4">
                  <div className="bg-light rounded p-2">
                    <small className="text-muted d-block">Invoice Amount</small>

                    <strong>
                      ₹{" "}
                      {Number(
                        invoicePayments[0]?.InvoiceAmount || 0,
                      ).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                      })}
                    </strong>
                  </div>
                </div>

                <div className="col-4">
                  <div className="bg-success bg-opacity-10 rounded p-2">
                    <small className="text-muted d-block">Paid Amount</small>

                    <strong className="text-success">
                      ₹{" "}
                      {Number(
                        invoicePayments[0]?.PaidAmount || 0,
                      ).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                      })}
                    </strong>
                  </div>
                </div>

                <div className="col-4">
                  <div className="bg-warning bg-opacity-10 rounded p-2">
                    <small className="text-muted d-block">Due Amount</small>

                    <strong className="text-warning">
                      ₹{" "}
                      {Number(
                        invoicePayments[0]?.DueAmount || 0,
                      ).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                      })}
                    </strong>
                  </div>
                </div>
              </div>

              {/* Table */}
              <div className="table-responsive">
                <table className="table table-sm table-bordered align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Date</th>
                      <th>Transaction ID</th>
                      <th>Amount</th>
                      <th>Payment Mode</th>
                    </tr>
                  </thead>

                  <tbody>
                    {invoicePayments.map((payment) => (
                      <tr key={payment.id}>
                        <td>
                          {payment.date
                            ? dayjs(payment.date).format("DD-MM-YYYY")
                            : "-"}
                        </td>
                        <td>
                          <span title={payment.transactionid || "-"}>
                            {payment.transactionid
                              ? payment.transactionid.length > 15
                                ? `${payment.transactionid.substring(0, 15)}...`
                                : payment.transactionid
                              : "-"}
                          </span>
                        </td>
                        <td className="fw-semibold">
                          ₹{" "}
                          {Number(payment.amount || 0).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                          })}
                        </td>

                        <td>
                          {payment.PaymentModeName ||
                            payment.paymentmethod ||
                            "-"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </Drawer>
  );
};

NewPayment.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,

  record: PropTypes.object,
};

export default NewPayment;
